import { Link } from 'react-router-dom';
import InterfaceHighlight from "../components/InterfaceHighlight";
import Tooltip from "../components/Tooltip";
import '../App.css';
import { useState, useEffect } from "react";
import RandomText from "../effects/RandomText";
import SlideInOutText from "../effects/SlideInOutText";

import Sticker from "../effects/Sticker";

export default function Home(){

    // const [data, setData] = useState([]);
    const [isStickerActive, setIsStickerActive] = useState(false);

    const data = [
        {
            id : "1bcafaf7-b684-8038-ac23-d66bc67f4193",
            title : "Teamstamps",
            impact : "Under test with a basketball league that holds season leagues with avg. 10 teams, 90 players, and 65 games.",
            date : "2025.01 - Current",
            summary : "Team Stamps is a team management tool designed for amateur sports leagues. The product aims to motivate players by bringing in professional broadcast experience through animated game graphics, player highlights, and stats.",
            link : "https://team-stamps.com/pfl/games",
            role : "Fullstack Developer",
            stack : `Frontend : React.js
Backend : Node.js`,
            videoSrc : [
                { url: "assets/teamstamps1.mp4", full: true },
            ]
        },
        {
            id : "2adafaf7-b684-80bc-9e30-e0b67fa113bb",
            title : "Daily Creative Coding",
            impact : "I’ve been posting daily sketch since Aug 1, 2023.",
            date : "2023.08.01 - Current",
            summary : "Experimenting around animations and educational interactive sketches. I also create custom graphics for video sources.",
            link : "https://www.instagram.com/coding.effects/",
            role : "Fullstack Developer",
            stack : ``,
            videoSrc : [
                { url : "assets/dailycc1.mp4", full : true },
            ]
        },
        {
            id : "25eafaf7-b684-80f5-916a-d572bdb527e0",
            title : "Graphbook",
            impact : "Alpha version released, under user test with two university professors to be used for courses and workshops.",
            date : "2025.07 - Current",
            summary : "Graphbook is an interactive blog editor built for creative coders and educators. It lets you write text, code, and present seamlessly in one place.",
            link : "https://graphbook.app/",
            role : "Design Engineer",
            stack : `Frontend : React.js
Database : Supabase
Deployment : Vercel`,
            videoSrc : [
                { url : "assets/interactiveblog.mp4", full : true },
            ]
        },
        {
            id : "170afaf7-b684-80e3-a118-c72096f5710e",
            title : "Quotes",
            impact : "Used internally in a weekly reading club since 2024.",
            date : "2024.03 - 2025.03",
            summary : "Quotes is a minimalistic editor designed to motivate your reading and writing experience.",
            link : "https://www.instagram.com/coding.effects/",
            role : "Fullstack Developer",
            stack : `Frontend : Next.js
Database : Postgres
Deployment : Vercel`,
            videoSrc : [
                { url : "assets/quotes.mp4", full : false },
            ]
        },
        {
            id : "334afaf7-b684-80d2-bcd1-e38af9cb774b",
            title : "Kinetic Typos Library",
            impact : "npm package released.",
            date : "2026.03",
            summary : "A library supporting a collection of customizable kinetic typo components, ready to be used in your code.",
            link : "https://kinetic-typos-jin-landing.vercel.app/",
            role : "",
            stack : ``,
            videoSrc : [
                { url : "https://storage.googleapis.com/imajindev/kinetictypos.mp4", full : true },
            ]
        },
    ];



    const streak = Math.floor((new Date() - new Date("2023-08-01")) / (1000 * 60 * 60 * 24));

    const handleStickerInteraction = (isActive) => {
        console.log("Sticker interaction active:", isActive);
        setIsStickerActive(isActive);
    };

    useEffect(() => {
        const preventScroll = (e) => {
            if (isStickerActive) {
                e.preventDefault();
            }
        };

        if (isStickerActive) {
            document.body.style.overflow = 'hidden';
            document.addEventListener('touchmove', preventScroll, { passive: false });
        }

        return () => {
            if (isStickerActive) {
                document.body.style.overflow = '';
                document.removeEventListener('touchmove', preventScroll);
            }
        };
    }, [isStickerActive]);

const mainText = `Hi! I'm Jin, a software engineer building products for purposeful interactions.`;

const subText = `I value making products that create real impact and honest interactions that help users to live purposeful lives. With 4 years of product designer experience, I specialize in frontend development and creative coding. I'm comfortable working across code, design, and motion : Javascript, React.js, p5.js, GLSL, Figma, After Effects.`;
    return(
        <div className = "" style = { { display : "flex", flexDirection : "column", paddingBottom : "80px" } }>
            
            <div className = "page" style = { { paddingTop : "160px", paddingBottom : "0px", position : "relative", } }>
                <div style = { { transform: "translateX(-36%)", position: "absolute", width : "400px", top : "64px", left : 0, zIndex : -1, }}>
                    <Sticker 
                        src="assets/profile.png" 
                        size={120} 
                        onInteractionChange={handleStickerInteraction} 
                        emojis={["🏀", "⚽", "🤜🤛", "👻"]} 
                        />
                </div>
                
                <div style = { { paddingTop : "190px", display : "flex", flexDirection : "column", gap : "8px", alignItems : "flex-start", width : "100%" } }>
                    <p style = { { lineHeight : "120%", fontSize : "var(--font-size-large)", whiteSpace : "pre-wrap", fontWeight : "500" } }>{ mainText }</p>
                    <p style={{ whiteSpace: "pre-wrap", paddingTop : "16px" }}>{ subText }</p>

                    <br/>
                    <p>I'm especially into sports, you'll find my experiments in this link :</p>

                    <Link to="/sportynerd" className = "sportyNerdLink">
                        <div style = { { display : "flex", alignItems : "center", gap : "4px", flexWrap : "wrap" } }>
                            
                            <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&lt;</p>
                            <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)" } }>🤜</p>
                            <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&gt;</p>
                            
                            <p style = { { fontFamily : "Cal Sans", fontSize : "var(--font-size-tiny)" } }>Jin the</p>
                            <RandomText txt = "Sporty" className = "homeText"/>
                            <SlideInOutText txt = "NERD" prevTxt = "nErD" fontSize = "20px" slideInColor = "var(--ptR)" slideOutColor = "var(--ptG)"/>
                            <p style = { { fontFamily : "Cal Sans", color : "var(--black72)", fontSize : "var(--font-size-tiny)" } }> : Dribbling around Sports and Creative</p>

                            <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&lt;/</p>
                            <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)" } }>🤛</p>
                            <p style = { { fontFamily : "var(--font-IBM)", fontSize : "var(--font-size-teeny)", color : "var(--black40)" } }>&gt;</p>
                        </div>
                    </Link>

                    <br/>
                    <p>I'm building..</p>
                </div>
            </div>

            { data.map ((item, index) => (
                <InterfaceHighlight
                    key={index}
                    title={item.title}
                    impact={item.impact}
                    date={item.date}
                    summary={item.summary}
                    link = {item.link ? item.link : `/works/${item?.id ?? ""}`}
                    videoSrc={item.videoSrc}
                />
            )) }
        </div>
    );
}